import { useState, useEffect } from "react";
import { Breadcrumb, Table, Switch } from "antd";
import Loader from "../../components/loader/loader";
import { addIcon, editIcon, redTrash } from "../../assets";
import { useNavigate } from "react-router-dom";
import { GreenNotify, RedNotify } from "../../helper/helper";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";

const Ticker = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [tickerItems, setTickerItems] = useState([]);

  const fetchTickerItems = () => {
    const onSuccess = (res) => {
      setTickerItems(res?.data?.data ?? []);
    };
    const onError = (err) => {
      console.log("Error fetching ticker items", err);
      RedNotify("Failed to load ticker items");
    };

    callApi("GET", routes.getTickerItems, null, setIsLoading, onSuccess, onError);
  };

  useEffect(() => {
    fetchTickerItems();
  }, []);

  const handleDelete = (id) => {
    const onSuccess = () => {
      setTickerItems((prev) => prev.filter((item) => item._id !== id));
      GreenNotify("Ticker item deleted successfully");
    };
    const onError = (err) => {
      console.log("Error deleting ticker item", err);
      RedNotify("Failed to delete ticker item");
    };

    callApi("DELETE", `${routes.deleteTickerItem}${id}`, null, setIsLoading, onSuccess, onError);
  };

  const handleActiveChange = (checked, record) => {
    const body = {
      active: checked,
    };

    const onSuccess = () => {
      setTickerItems((prev) =>
        prev.map((item) => (item._id === record._id ? { ...item, active: checked } : item)),
      );
      GreenNotify(checked ? "Ticker item activated" : "Ticker item deactivated");
    };
    const onError = (err) => {
      console.log("Error updating ticker item", err);
      RedNotify("Failed to update ticker item");
    };

    callApi("PATCH", `${routes.updateTickerItem}${record._id}`, body, setIsLoading, onSuccess, onError);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "order",
      key: "order",
      width: 60,
      align: "center",
      className: "role-name-column-header",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      align: "center",
      className: "type-name-column-header",
      render: (type) => (type === "image" ? "Image" : "Text"),
    },
    {
      title: "Content / Preview",
      dataIndex: "value",
      key: "value",
      className: "role-name-column-header",
      render: (value, record) =>
        record.type === "image" ? (
          <img src={value} alt="Ticker" style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }} />
        ) : (
          <span style={{ maxWidth: 320, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {value}
          </span>
        ),
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      align: "center",
      className: "action-column-header",
      render: (active, record) => (
        <Switch checked={active} onChange={(checked) => handleActiveChange(checked, record)} />
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = tickerItems.map((item, index) => ({
    key: item._id,
    ...item,
    edit: (
      <div
        onClick={() => navigate("/edit-ticker-item", { state: { item } })}
        style={{ cursor: "pointer" }}
      >
        <img src={editIcon} alt="edit" />
      </div>
    ),
    delete: (
      <div onClick={() => handleDelete(item._id)} style={{ cursor: "pointer" }}>
        <img src={redTrash} alt="delete" />
      </div>
    ),
  }));

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) return "server-role-even-row";
    return "server-role-odd-row";
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />

      <Breadcrumb
        separator=">"
        className="bread-crumb"
        items={[
          { title: "Home" },
          { title: "Ticker" },
        ]}
      />

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "2rem",
        }}
      >
        <h1>Ticker Management</h1>
        <div
          onClick={() => navigate("/new-ticker-item")}
          style={{
            padding: "8px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            background: "#0C3C9E",
            cursor: "pointer",
            gap: 10,
          }}
        >
          <img src={addIcon} alt="" />
          <p style={{ color: "white" }}>Add Ticker Item</p>
        </div>
      </div>

      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={{ pageSize: 10 }}
          className="subscriptionapi-table"
        />
      </div>
    </div>
  );
};

export default Ticker;
